<template>
  <div class="form__block login_as">

    <section class="form_inner">
      <img class="staff_loginlogo"
        src="https://pixelarchivenow.com/dticash_assets/header/logo.svg">
      <h3>Staff Login Test SW</h3>

      <form @submit.prevent="handleSubmit">
        <div class="front-form-area">
          <label for="userid">
            <input class="form-control" type="type" id="userid" v-model="userid"
              :placeholder="$t('userid')"></label>

          <button type="submit" :class="['login-bt', { 'active': userid }]"
            :disabled="userid ? false : true">
            {{ $t('login.login') }}</button>
        </div>
        <div class="error_msg" v-if="error">
          {{ error }}
        </div>
      </form>
      <dl class="noteforstaff" v-if="env">
        <dt>How to Avoid Account Page Authentication?</dt>
        <dd>
          <p>Add parameter <span class="red">?xE4it=true</span> to avoid account
            page authentication. Available in DEV/STG.
            <a href="#" @click.prevent="loginAndRedirect"
              class="sample-url">/accounts?xE4it=true</a>
          </p>
        </dd>
      </dl>
      <p v-else>production</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'LoginAs',
  data() {
    return {
      userid: null,
      error: null,
      env: process.env.VUE_APP_ENV != 'production' ? true : false
    }
  },
  methods: {
    handleSubmit() {
      this.loginas('/dashboard');
    },
    loginAndRedirect() {
      if (!this.userid) {
        alert('Please enter a user ID first');
        return;
      }
      this.loginas('/accounts?xE4it=true');
    },
    loginas(redirectPath = '/dashboard') {
      return new Promise((resolve, reject) => {
        const loginParams = { userid: this.userid };
        this.$store.dispatch("auths/loginAsAction", loginParams)
          .then(login => {
            this.loginSuccessful(login, redirectPath);
            resolve(login);
          })
          .catch(error => {
            this.loginFailed(error);
            reject(error);
          });
      });
    },
    loginSuccessful(response, redirectPath) {
      if (!response.access_token) {
        this.loginFailed(response)
        return
      }

      localStorage.csrf = response.access_token;
      localStorage.expire = response.access_expire_at;
      localStorage.refresh = response.refresh_token;
      localStorage.refresh_expire = response.refresh_expire_at;
      localStorage.userid = this.userid;
      localStorage.logIn = true;
      this.$emit('endTime', localStorage.refresh_expire)
      this.error = ''
      console.log('Redirecting to:', redirectPath);
      this.$nextTick(() => {
        this.$router.push(redirectPath);
      });
    },
    deleteLocalStorage() {
      console.log('Delete localStorage');
      localStorage.clear();
    },
    loginFailed(error) {
      console.log(error);
      const status = error.response?.status || '';
      this.error = status + ': ' + (error.response.data.message || '');
      this.deleteLocalStorage();
    }
  }
}
</script>

<style scoped>
@import '@/assets/front/form.css';

.login_as {
  background: url('https://pixelarchivenow.com/dticash_assets/front/webp/office.webp') no-repeat;
  background-size: cover;
  max-width: 100%;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login_as .form_inner {
  max-width: 500px;
  width: 100%;
  padding: 3em 0 4em;
  background-color: #eeeeeeeb;
  border-radius: 10px;
  margin-bottom: 10%;
}

.login_as h3 {
  color: #2c6b7a;
  text-transform: uppercase;
}

.login_as label {
  width: calc(70% - 4em);
  border: 1px solid #2c6b7a;
  border-radius: 5px;
}

.login_as button.active {
  background-color: #018264;
  color: #fff;
}

.login_as .staff_loginlogo {
  max-width: 300px;
  margin: 0 auto 2em;
}

.login_as .noteforstaff {
  color: #222;
  text-align: left;
  padding: 4em 1em 0 3em;
}

.login_as .noteforstaff dt,
.login_as .noteforstaff dd {
  display: flex;
  column-gap: 1rem;
  margin-bottom: 1em;
}

.login_as .noteforstaff dt {
  align-items: center;
}

.login_as .noteforstaff p {
  width: calc(100% - 4rem);
}

.login_as .noteforstaff dt::before,
.login_as .noteforstaff dd::before {
  display: inline-block;
  width: 3.3rem;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  border-radius: 50%;
  color: #fff;
}

.login_as .noteforstaff dt::before {
  content: "Q";
  background-color: #018264;
}

.login_as .noteforstaff dd::before {
  content: "A";
  background-color: #f45201;
}

.login_as .sample-url {
  display: block;
  text-align: center;
  background-color: #cdf4eb;
  padding: .5rem;
  width: 50%;
  margin: 1rem 0;
}
</style>
